'use strict';

require('../../company/CompanyService.js');
require('../../company/publications/CompanyPublicationService.js');
require('../GuestPublicationImageDirective.js');

function CompanyGuestPublicationsListCtrl(
  $scope,
  $stateParams,
  $state,
  publications,
  translations,
  currentPortal
) {
  $scope.publications = publications;
  $scope.$state = $state;
  $scope.priorityId = $stateParams.priorityId || null;
  $scope.more = false;
  $scope.title = translations['all-cards'];
  $scope.currentPortal = currentPortal;

  $scope.removeCategoryFilter = function() {
    $state.go($state.current.name, {categoryId: null});
  };

  if (!$stateParams.categoryId) {
    $scope.activeCategory = null;
  } else {
    $scope.$parent.categories.forEach(function(c) {
      if (c.id === $stateParams.categoryId) {
        $scope.activeCategory = c.name;
      }
    });
  }

  if($scope.publications.length === 21) {
    $scope.more = true;
    $scope.publications.pop();
  }

  if ($stateParams.groupId) {
    $scope.title = currentPortal.name;
  }

  $scope.$on('$select.select', function(ev, priorityId) {
    $scope.priorityId = priorityId;
    if(!$scope.priorityId) {
      $scope.priorityId = null;
    }
    var filter = {
      priorityId: $scope.priorityId,
      page: null
    };
    $state.go('root.company-guest.publications.list', filter);
  });

  $scope.page = parseInt($stateParams.page, 10) || 1;
  $scope.companyId = $stateParams.companyId;

}

CompanyGuestPublicationsListCtrl.resolve = {
  publications: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    var companyId = $stateParams.companyId,
    filter = {};

    filter.companyId = companyId;
    if('' !== $stateParams.q) {
      filter.q     = $stateParams.q;
      filter.qType = $stateParams.qType || "GENERAL";
      if (filter.qType === "REFERENCE" || filter.qType === 'KEYPASS') {
        if (filter.qType === 'REFERENCE') {
          filter.reference = filter.q;
        } else if (filter.qType === 'KEYPASS') {
          filter.keypass = filter.q;
          filter.type = 'KEYPASS';
        }
        filter.q = '';
        filter.qType = '';
      }
    }
    if('' !== $stateParams.categoryId) {
      filter.categoryId = $stateParams.categoryId;
    }
    if('' !== $stateParams.priorityId) {
      filter.priorityId = $stateParams.priorityId;
    }
    if('' !== $stateParams.tags) {
      filter.tags = $stateParams.tags;
    }
    if('' !== $stateParams.groupId) {
      filter.groupId = $stateParams.groupId;
    }

    // Fetch 21 for pagination, but the offset should be using 20
    filter.limit = 21;
    var page = parseInt($stateParams.page, 10) || 1;
    filter.offset = (page - 1) * 20;

    return CompanyPublicationService.query(filter).$promise;
  }],
  currentPortal: ['$stateParams', '$window', 'CompanyGroupService', function($stateParams, $window, CompanyGroupService) {
    if ($stateParams.groupId) {
      return CompanyGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId, type: 'VISIBLE'}).$promise;
    }
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'all-cards',
      'customer-portal.template.default',
      'customer-portal.template.my-page'
    ]);
  }]
};
module.exports = CompanyGuestPublicationsListCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPublicationsListCtrl', [
    '$scope',
    '$stateParams',
    '$state',
    'publications',
    'translations',
    'currentPortal',
    CompanyGuestPublicationsListCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/publications/CompanyGuestPublicationsListCtrl.js
// module id = 301
// module chunks = 0